import type { CupsPrinterInfo } from './thermalReceiptTypes.js';

export { mapOsPrinterToCupsInfo } from './mapOsPrinter.js';

/** Prefer CUPS entries when names collide; append OS-only printers. */
export function mergePrinterLists(
  cups: CupsPrinterInfo[],
  os: CupsPrinterInfo[],
): CupsPrinterInfo[] {
  const byName = new Map<string, CupsPrinterInfo>();
  for (const printer of cups) {
    byName.set(printer.name, printer);
  }
  for (const printer of os) {
    if (!byName.has(printer.name)) {
      byName.set(printer.name, printer);
    }
  }
  return [...byName.values()];
}
